import { render, staticRenderFns } from "./DashboardKpiEventsWidget.vue?vue&type=template&id=a3c8d060&scoped=true"
import script from "./DashboardKpiEventsWidget.vue?vue&type=script&lang=js"
export * from "./DashboardKpiEventsWidget.vue?vue&type=script&lang=js"
import style0 from "./DashboardKpiEventsWidget.vue?vue&type=style&index=0&id=a3c8d060&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c8d060",
  null
  
)

export default component.exports